var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_891_15580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.62876 10.1855C8.07088 10.1855 7.61863 10.6378 7.61863 11.1956C7.61863 11.7535 8.07088 12.2058 8.62876 12.2058H16.7098C17.2676 12.2058 17.7199 11.7535 17.7199 11.1956C17.7199 10.6378 17.2676 10.1855 16.7098 10.1855H8.62876Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62876 14.226C8.07088 14.226 7.61863 14.6783 7.61863 15.2361C7.61863 15.794 8.07088 16.2463 8.62876 16.2463H12.6693C13.2271 16.2463 13.6794 15.794 13.6794 15.2361C13.6794 14.6783 13.2271 14.226 12.6693 14.226H8.62876Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62876 18.2665C8.07088 18.2665 7.61863 18.7188 7.61863 19.2766C7.61863 19.8345 8.07088 20.2868 8.62876 20.2868H16.7098C17.2676 20.2868 17.7199 19.8345 17.7199 19.2766C17.7199 18.7188 17.2676 18.2665 16.7098 18.2665H8.62876Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6379 6.28398C21.5567 6.08724 21.4373 5.90849 21.2868 5.75801L18.1073 2.57858C17.8045 2.2754 17.3937 2.10487 16.9652 2.10449H5.19433C4.76568 2.10449 4.3546 2.27477 4.0515 2.57787C3.7484 2.88096 3.57812 3.29205 3.57812 3.72069V22.7111C3.57812 22.9233 3.61993 23.1335 3.70115 23.3296C3.78237 23.5256 3.90142 23.7038 4.0515 23.8539C4.20158 24.004 4.37974 24.123 4.57583 24.2042C4.77193 24.2855 4.98209 24.3273 5.19433 24.3273H20.1442C20.3564 24.3273 20.5666 24.2855 20.7627 24.2042C20.9588 24.123 21.1369 24.004 21.287 23.8539C21.4371 23.7038 21.5562 23.5256 21.6374 23.3296C21.7186 23.1335 21.7604 22.9233 21.7604 22.7111V6.9029L20.7503 6.90259L21.7604 6.90507L21.7604 6.9029C21.7606 6.69056 21.719 6.48024 21.6379 6.28398ZM15.6996 6.65006C15.6996 7.48688 16.378 8.16525 17.2148 8.16525H19.7401V22.307H5.59838V4.12474H15.6996V6.65006ZM18.8167 6.145L17.7199 5.04822V6.145H18.8167Z",
    fill: "white",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_891_15580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.243,
    height: 24.243,
    fill: "white",
    transform: "translate(0.546875 0.608398)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleWhite);
export default __webpack_public_path__ + "static/media/sale_white.554c39be71f4fcd4f568ed288beed762.svg";
export { ForwardRef as ReactComponent };